import {createContext, useContext, useEffect, useState} from 'react';

const ShowValuesContext = createContext();

export const useShowContext = () => {
    return useContext(ShowValuesContext);
};

export const ShowValuesProvider = ({ children }) => {
    const [showValue, setShowValue] = useState(true);

    useEffect(() => {
        // Verifica se há um valor armazenado no LocalStorage
        const storedShowValue = localStorage.getItem('show_values');
        if (storedShowValue !== null) {
            setShowValue(storedShowValue === 'true');
        }
    }, []);

    const toggleShowValue = () => {
        const newViewValue = !showValue;
        setShowValue(newViewValue);
        localStorage.setItem('show_values', newViewValue.toString());
    };

    return (
        <ShowValuesContext.Provider value={{ showValue, toggleShowValue }}>
            {children}
        </ShowValuesContext.Provider>
    );
};
